<template>
    <div>
        <DxForm ref="formInstance" :form-data="model">
            <DxGroupItem>
                <DxItem data-field="Nombre" editor-type="dxTextBox" :editorOptions="{ 'maxLength': '200' }"
                    :disabled="true">
                    <DxLabel :text="$t('instalaciones.popup_anadir_instalacion.nombre')" />
                    <DxRequiredRule :message="$t('zonas.popup_guardar_zona.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="IdRegion" editor-type="dxSelectBox" :editor-options="regionEditorOptions"
                    :col-span="6">
                    <DxLabel :text="$t('zonas.popup_guardar_zona.id_region')" />
                    <DxRequiredRule :message="$t('zonas.popup_guardar_zona.mensaje_validacion_obligatorio')" />
                </DxItem>

                <DxItem data-field="IdUsuarioJefe" editor-type="dxSelectBox" :editor-options="jefeEditorOptions"
                    :col-span="6">
                    <DxLabel :text="$t('zonas.popup_guardar_zona.id_usuario_jefe')" />
                    <DxRequiredRule :message="$t('zonas.popup_guardar_zona.mensaje_validacion_obligatorio')" />
                </DxItem>
            </DxGroupItem>
        </DxForm>
    </div>
</template>

<script setup lang="ts">
import { DxForm } from "devextreme-vue";
import { useIntl } from '@services/i18n';
import { useApi } from '@/.shared/.api/integration';
import type { EditZonaModel } from '@/.shared/.api';
import { DxRequiredRule } from "devextreme-vue/data-grid";
import type { ValidationCallbackData } from 'devextreme/common';
import { computed, getCurrentInstance, onMounted, ref, } from 'vue';
import { useModalBuilder } from '@/.shared/helpers/modal-building-helper';
import { validateDxFormAsync } from '@/.shared/helpers/dxvalidation-helper';
import { toastSuccess, toastError } from '@/.shared/services/notification-service';
import { DxGroupItem, DxItem, DxLabel, DxColCountByScreen, DxAsyncRule } from "devextreme-vue/form";

const props = defineProps<{ zonaProp: EditZonaModel }>();
const editing = computed(() => props.zonaProp != null);
const model = computed(() => (editing.value) ? props.zonaProp : {} as EditZonaModel);
const idZona = computed(() => (!editing.value) ? undefined : (model.value as EditZonaModel).Id);

const api = useApi();
const intl = useIntl();
const modalBuilder = useModalBuilder();

const formInstance = ref<DxForm>();
const regionEditorOptions = ref<any>(
    {
        displayExpr: "Nombre",
        valueExpr: "Id",
        searchEnabled: "true"
        // onValueChanged: tipoComunicadoChanged
    });
const jefeEditorOptions = ref<any>(
    {
        displayExpr: "NombreCompleto",
        valueExpr: "Id",
        searchEnabled: "true"
        // onValueChanged: tipoComunicadoChanged
    });

onMounted(async () => {
    modalBuilder.setContext(getCurrentInstance()!);

    let botones = modalBuilder.standardButtons.addOkCancel();
    botones.okButton.update((b) => {
        b.text = intl.i18n.t("zonas.popup_guardar_zona.boton_anadir_zona")
        b.onClick = async () => {
            const result = await validateDxFormAsync(formInstance.value!.instance!);
            if (result.isValid) {
                if (editing.value) {
                    await api.callStandardApi("zonaEdit", { showLoading: true }, model.value as EditZonaModel);
                    toastSuccess(intl.i18n.t('zonas.popup_guardar_zona.mensaje_zona_editada'));
                }
                modalBuilder.close(true);
            } else {
                toastError(intl.i18n.t('zonas.popup_guardar_zona.mensaje_validacion_no_superada'));
            }
        }
    });

    botones.cancelButton.update((b) => {
        b.onClick = async () => {
            // const result = await modalService.messageBox('¿Está seguro de que desea cancelar?', 'Confirmación', 'yesNo', 'warning');
            //      if (result === 'yes')
            modalBuilder.close(false);
        }
    });

    await rellenarRegiones();
    await rellenarJefesZona();
});

async function rellenarRegiones(): Promise<void> {
    const data = await api.callStandardApi("regionGetTodas", { showLoading: true });
    regionEditorOptions.value = { ...regionEditorOptions, dataSource: data };
}

async function rellenarJefesZona(): Promise<void> {
    const data = await api.callStandardApi("usuarioGetTodos", { showLoading: true });
    jefeEditorOptions.value = { ...jefeEditorOptions, dataSource: data };
}
</script>